import { Box, Grid } from "@mui/material";
import { useMediaQuery } from "@mui/system";
import {
  EditButton,
  FunctionField,
  Labeled,
  ReferenceField,
  Show,
  SimpleShowLayout,
  TextField,
} from "react-admin";
import { settings } from "app";
import permissions from "app/permissions";
import { administrationRequests } from "api/administrationApi";
import { erasmusRequests } from "api/erasmusApi";
import BackButtonToolbar from "features/BackButtonToolbar";
import { SectionTitle } from "features/SectionTitle";
import SecuredComponent from "server/security/SecuredComponent";
import { getCoordinatorName } from "./utils";

const ShowErasmusCoordinators = () => {
  const isMobile = useMediaQuery(theme => theme.breakpoints.down("md"));
  const shadow = isMobile ? settings.style.shadowBoxMobile : settings.style.shadowBox;

  return (
    <Show
      title="Детайли за координатор"
      actions={
        <BackButtonToolbar
          additionalButton={
            <SecuredComponent permission={permissions.canManageErasmusCoordinators}>
              <EditButton
                variant="contained"
                size="medium"
              />
            </SecuredComponent>
          }
        />
      }
    >
      <SimpleShowLayout>
        <SectionTitle
          paddingY={2}
          title="Основна информация"
          textAlign="center"
        />
        <Box sx={shadow}>
          <Grid
            container
            spacing={2}
          >
            <Grid
              item
              xs={12}
              md={4}
            >
              <Labeled label="Служител">
                <FunctionField render={getCoordinatorName} />
              </Labeled>
            </Grid>
            <Grid
              item
              xs={12}
              md={4}
            >
              <Labeled label="Структурна единица">
                <ReferenceField
                  source="structuralUnitId"
                  reference={administrationRequests.getStructuralUnitsSelect()}
                >
                  <TextField source="name" />
                </ReferenceField>
              </Labeled>
            </Grid>
            <Grid
              item
              xs={12}
              md={4}
            >
              <Labeled label="Статус">
                <ReferenceField
                  source="status"
                  reference={erasmusRequests.getCoordinatorStatusesSelect()}
                >
                  <TextField source="nameBg" />
                </ReferenceField>
              </Labeled>
            </Grid>
            <Grid
              item
              xs={12}
              md={6}
            >
              <Labeled label="Адрес (на латиница)">
                <TextField source="addressEn" />
              </Labeled>
            </Grid>
          </Grid>
        </Box>
      </SimpleShowLayout>
    </Show>
  );
};

export default ShowErasmusCoordinators;
